var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { overflow: "hidden", width: "100%", height: "100%" } },
    [
      !_vm.showLink
        ? _c("img", {
            style: _vm.imageAdapter,
            attrs: { src: _vm.element.propValue },
          })
        : _vm._e(),
      _vm.showLink
        ? _c(
            "a",
            {
              attrs: {
                title: _vm.element.hyperlinks.content,
                target: _vm.element.hyperlinks.openMode,
                href: _vm.element.hyperlinks.content,
              },
            },
            [
              _c("img", {
                style: _vm.imageAdapter,
                attrs: { src: _vm.element.propValue },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }